module.exports = __webpack_public_path__ + "img/issuing-sample-badgeV3.4afa9d2d.svg";